<nb-tabset>
    <nb-tab tabTitle="Usuarios - Operadores" tabIcon="people-outline" responsive>
        <app-sub-usuarios-operador></app-sub-usuarios-operador>
    </nb-tab>
</nb-tabset>